import { Component } from '@angular/core';

@Component({
  selector: 'app-aigc-step',
  templateUrl: './aigc-step.component.html',
  styleUrls: ['./aigc-step.component.scss'],
})
export class AigcStepComponent {
  reason = [
    {
      img: '../../../../assets/images/yunlogin/Icon-daohanghaiwaigou.webp',
      text1: '无需海外网络接入',
      text2: '即使在国内，也能畅享GPT服务',
    },
    {
      img: '../../../../assets/images/yunlogin/Icon-problemlimitations.webp',
      text1: '解决4.0提问限制',
      text2: '突破提问次数限制，畅享无界限问答体验',
    },
    {
      img: '../../../../assets/images/yunlogin/Icon-personaccount.webp',
      text1: '个人专享账号',
      text2: '一人一号避免提问冲突',
    },
    {
      img: '../../../../assets/images/yunlogin/Icon-price.webp',
      text1: '超值价格',
      text2: '低至2.3元/天，享受高性价比服务',
    },
    {
      img: '../../../../assets/images/yunlogin/Icon-nativeexperience.webp',
      text1: '原生态体验',
      text2: '提供原生的ChatGPT Plus体验',
    },
    {
      img: '../../../../assets/images/yunlogin/Icon-stabilize.webp',
      text1: '稳定可靠',
      text2: '自上线以来，无一账号被封',
    },
  ];
  list = [
    {
      title: '在云登浏览器使用ChatGPT是否会导致账号封禁？',
      content:
        '在大陆地区使用ChatGPT存在一定的封禁风险，通过云登浏览器的防指纹识别技术使用ChatGPT可以大幅度降低封禁的可能性。',
    },
    {
      title: '在云登浏览器上使用ChatGPT与官方网站有何区别？',
      content:
        '在网页端，两者完全一样，没有任何区别。唯一的区别在于手机端目前暂时还不支持使用，在努力开发中…',
    },
    {
      title: '使用ChatGPT需要什么网络条件？',
      content:
        '通过云登使用ChatGPT不需要特殊的网络条件。如果遇到无法启动的情况，请直接联系我们的客服团队获取支持。',
    },
    {
      title: '页面左侧出现了不相关的对话窗口，该如何处理？',
      content:
        '专车账号为灵活分配，您不使用时会分配给他人您可以在ChatGPT的设置中清空对话，以解决左侧出现不相关对话窗口的问题。',
    },
    {
      title: '如何进行再次购买或续费？',
      content:
        '您可以选择在环球巴士上进行再次购买或续费（请确保在会员到期前进行续费操作）。',
    },
    {
      title: '提问上限怎么办？',
      content:
        '如果达到提问上限，请关闭当前窗口，然后点击界面中的账号切换按钮。系统将为您分配一个新账号继续使用。',
    },
    {
      title: '什么是“专车”服务？',
      content:
        '“专车”意味着在您使用期间，该账号仅供您一人使用。当您结束使用后，该账号会重新分配给其他用户。',
    },
    {
      title: '使用中需要注意什么？',
      content:
        '建议您在每次对话结束时保存聊天记录。由于账号不具备绑定功能，下次登录可能会接入不同的账号，因此先前的问答记录无法恢复。如需稳定的聊天记录，可考虑购买“包车”服务。',
    },
    {
      title: '提问技巧',
      content:
        '无需发送诸如“你好”、“在吗”或“我有个问题”之类的开场白，因为这些都会占用您的提问次数。建议直接提出完整且具体的问题，以最大化每次提问的价值。',
    },
  ];

  download() {
    window.open('https://www.yunlogin.com/download');
  }
}
